import React from "react";
import { Card, Button } from "react-bootstrap";

export default function BrokerageSupportSection({ referralLink }) {
  return (
    <Card className="mt-5 shadow-sm border-0 bg-light">
      <Card.Body className="p-4">
        <h5 className="mb-3">💼 Ready to Build This Portfolio?</h5>

        <p className="text-muted mb-3">
          To invest in this portfolio, you’ll need a brokerage account.
          I personally use Robinhood because it’s simple and beginner-friendly.
        </p>

        <p className="text-muted mb-4">
          If you decide to use my referral link, you’ll receive a free stock —
          and it helps support Stocks With Nik at no extra cost to you.
          Totally optional. Use whatever brokerage you’re comfortable with.
        </p>

        <Button
          href={referralLink}
          target="_blank"
          rel="noopener noreferrer"
          variant="dark"
        >
          Open a Brokerage Account + Get Free Stock
        </Button>

        <p className="small text-muted mt-3 mb-0">
          Disclosure: This is a referral link. I may receive a reward if you sign up.
        </p>
      </Card.Body>
    </Card>
  );
}